import Columns from './columns';
import {displayModes} from '../../../../../../services/enums/displayModes';

// CARE: ALWAYS INCREMENT THE VERSION IF THE SETTINGS FOR A COLUMN CHANGE!
// Config explanation
// optional: determines if the hidden status can be changed by the user
// hidden: determines if the field is shown or hidden
// conditional: indicates that the hidden status can be overriden using the conditions dictionary of the useTableConfig hook
const DefaultConfig = {
  [displayModes.admin]: {
    version: 1,
    columns: {}
  },
  [displayModes.carrier]: {
    version: 1,
    columns: {
      stopNumber: {
        columnName: Columns.stopNumber.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 1,
      },
      shipper: {
        columnName: Columns.shipper.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 2
      },
      deliveryTimeWindowShipper: {
        columnName: Columns.deliveryTimeWindowShipper.name,
        optional: true,
        hidden: true,
        conditional: false,
        order: 3
      },
      lastName: {
        columnName: Columns.lastName.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 4
      },
      streetAndNumber: {
        columnName: Columns.streetAndNumber.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 5
      },
      microHub: {
        columnName: Columns.microHub.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 6
      },
      remove: {
        columnName: Columns.remove.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 7
      }
    }
  },
  [displayModes.shipper]: {
    version: 1,
    columns: {}
  },
}

export default DefaultConfig;